/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import { CioConditionViewerBaseArgs } from 'cio/components/cio-condition-viewer-base';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';

interface CioConditionViewerEventAttributeArgs extends CioConditionViewerBaseArgs {
  campaign?: CampaignModel;
  condition: EventAttributeCondition;
  fieldClass?: string;
  operatorClass?: string;
  showName?: boolean;
  showBlank?: boolean;
  stripOperatorIs?: boolean;
  tagName?: string;
  isEventAttribute?: boolean;
  depth?: number;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
  labelClasses?: string;
}

export default class CioConditionViewEventAttribute extends Component<CioConditionViewerEventAttributeArgs> {}
